import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/lib/useDocumentMeta';

// The App Router served Next's built-in 404 for unmatched paths. A static SPA
// answers every path with index.html and a 200, so the "not found" state has to
// be a route. Search engines will see a soft 404 here — if that matters, the
// nginx config can serve a real 404 for known-bad prefixes.
export default function NotFound() {
  useDocumentMeta('Page not found · RateMyHYSA', 'That page does not exist.');

  return (
    <main className="wrap">
      <article className="post">
        <h1>Page not found</h1>
        <p>
          That page doesn&rsquo;t exist. Try the <Link to="/">rate check</Link> or the{' '}
          <Link to="/blog">monthly rate reports</Link>.
        </p>
      </article>
    </main>
  );
}
